
import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { ResultsCategoriesData } from '../types';

/**
 * typeguard for ResultsCategoriesQuery
 * @param ResultsCategoriesQuery object passed to transformer
 */
export const isValidResultsCategories = (obj: ResultsCategoriesData): boolean => Boolean(obj?.data?.getResultsCategoriesWidget && !isEmptyObject(obj.data.getResultsCategoriesWidget));
